<template>
  <div>
    <b-row>
      <b-col cols="12">
        <b-card class="mb-3" title="Media Listesi">
          <b-alert variant="warning" show class="mb-0">
            <div class="alert-body mb-2">
              <span
                ><strong>Not:</strong> Eklenecek dosya boyutu 100mb dan büyük olmamalı ve
                jpeg,png,jpg,gif,svg,pdf,xls,xlsx,doc,docx,mp4,mp3 formatlarından biri
                olmalıdır.</span
              >
            </div>
          </b-alert>
        </b-card>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="12">
        <b-card class="mb-3" title="Dosya Yükleme">
          <b-form-file
            placeholder="Bir dosya seçin veya buraya bırakın..."
            drop-placeholder="Dosyayı buraya bırakın..."
            multiple
            v-model="medias"
            ref="medias"
            accept=".jpeg, .png, .jpg, .gif, .svg, .pdf, .xls, .xlsx, .doc, .docx, .mp4, .mp3"
            @change="handleMediaUpload"
          />
        </b-card>
      </b-col>
    </b-row>
    <b-row v-if="medias.length > 0">
      <b-col cols="12">
        <b-alert variant="success" show class="mb-0">
            <div class="alert-body mb-2">
              <span>Lütfen dosyalarınız yüklenene kadar bekleyiniz.</span
              >
            </div>
          </b-alert>
      </b-col>
      </b-row>
    <b-row v-if="medias.length > 0">
      <b-col cols="12">
        <b-card class="mb-3" title="Dosyalar">
          <b-form>
            <b-row>
              <b-col cols="12">
                <table class="table b-table">
                  <thead>
                    <th>İSİM</th>
                  </thead>
                  <tbody>
                    <tr v-for="(media, index) in medias" :key="`media-${index}`">
                      <td>{{ media.name }}</td>
                    </tr>
                  </tbody>
                  <thead>
                    <th>İSİM</th>
                  </thead>
                </table>
              </b-col>
            </b-row>
          </b-form>
        </b-card>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="12" class="mb-2 mt-2">
        <b-card class="mb-3" title="Medialar">
          <b-row>
            <b-col cols="12">
              <b-row>
                <b-col md="4"> </b-col>
                <b-col md="4">
                  <div class="mb-2">
                    <b-form-input v-model="name" placeholder="Dosya Adı" />
                  </div>
                  <div class="mb-2">
                    <b-form-group label="Başlangıç Tarihi" label-for="startDate">
                      <b-form-datepicker
                        :date-format-options="{
                          year: 'numeric',
                          month: 'numeric',
                          day: 'numeric',
                        }"
                        locale="tr"
                        v-model="startDate"
                      />
                    </b-form-group>
                  </div>
                  <div class="mb-2">
                    <b-form-group label="Bitiş Tarihi" label-for="endDate">
                      <b-form-datepicker
                        :date-format-options="{
                          year: 'numeric',
                          month: 'numeric',
                          day: 'numeric',
                        }"
                        locale="tr"
                        v-model="endDate"
                      />
                    </b-form-group>
                  </div>
                  <div class="mb-2 d-flex justify-content-center align-items-center">
                    <b-button
                      class="float-right"
                      v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                      variant="outline-success"
                      target="_blank"
                      v-on:click="getMedias(1)"
                    >
                      Filtrele
                    </b-button>
                  </div>
                </b-col>
                <b-col md="4"> </b-col> </b-row
            ></b-col>
          </b-row>
          <b-row>
            <b-col cols="12">
              <div class="d-flex justify-content-center align-items-center">
                <table class="table b-table table-responsive w-auto">
                  <thead>
                    <th>ID</th>
                    <th>İSİM</th>
                    <th>BOYUT</th>
                    <th>UZANTI</th>
                    <th>MIME/TYPE</th>
                    <th>BAĞLANTI LİNKİ</th>
                    <th>GÖRÜNTÜLE</th>
                    <th>OLUŞTURMA TARİHİ</th>
                  </thead>
                  <tbody>
                    <tr v-for="mediaData in mediaDatas" :key="mediaData.id">
                      <td>{{ mediaData.id }}</td>
                      <td>{{ mediaData.name }}</td>
                      <td>{{ (mediaData.size / 1204).toFixed(2) }} KB</td>
                      <td>{{ mediaData.extension }}</td>
                      <td>{{ mediaData.mimeType }}</td>
                      <td>
                        <b-button v-on:click="copy(mediaData.path)"> KOPYALA </b-button>
                      </td>
                      <td>
                        <b-button target="_blank" :href="mediaData.path">
                          GÖRÜNTÜLE
                        </b-button>
                      </td>
                      <td>{{ mediaData.createdAt }}</td>
                    </tr>
                  </tbody>
                  <thead>
                    <th>ID</th>
                    <th>İSİM</th>
                    <th>BOYUT</th>
                    <th>UZANTI</th>
                    <th>MIME/TYPE</th>
                    <th>BAĞLANTI LİNKİ</th>
                    <th>GÖRÜNTÜLE</th>
                    <th>OLUŞTURMA TARİHİ</th>
                  </thead>
                </table>
              </div>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12">
              <div class="d-flex justify-content-center align-items-center">
                <b-pagination
                  :value="1"
                  :total-rows="rows"
                  :per-page="12"
                  first-number
                  last-number
                  align="right"
                  prev-class="prev-item"
                  next-class="next-item"
                  class="mt-1 mb-0"
                  @input="(value) => getMedias(value)"
                >
                  <template #prev-text>
                    <feather-icon icon="ChevronLeftIcon" size="18" />
                  </template>
                  <template #next-text>
                    <feather-icon icon="ChevronRightIcon" size="18" />
                  </template>
                </b-pagination>
              </div> </b-col
          ></b-row>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import Ripple from "vue-ripple-directive";
import { ValidationProvider, ValidationObserver } from "vee-validate";

import {
  BRow,
  BCol,
  BImg,
  BCard,
  BForm,
  BBadge,
  BAlert,
  BButton,
  BAvatar,
  BFormFile,
  BCardText,
  BFormGroup,
  BFormInput,
  BPagination,
  BButtonGroup,
  BListGroupItem,
  BButtonToolbar,
  BFormDatepicker,
} from "bootstrap-vue";

import {
  required,
  email,
  confirmed,
  url,
  between,
  alpha,
  integer,
  password,
  min,
  digits,
  alphaDash,
  length,
} from "@validations";
import settings from "../../../settings";
import { Endpoints } from "@core/endpoints/endpoints";
const endpoints = new Endpoints();

export default {
  components: {
    BRow,
    BCol,
    BImg,
    BCard,
    BForm,
    BAlert,
    BBadge,
    BButton,
    BAvatar,
    BFormFile,
    BCardText,
    BFormGroup,
    BFormInput,
    BPagination,
    BButtonGroup,
    BButtonToolbar,
    BListGroupItem,
    BFormDatepicker,
    ValidationProvider,
    ValidationObserver,
    required,
    email,
    confirmed,
    url,
    between,
    alpha,
    integer,
    password,
    min,
    digits,
    alphaDash,
    length,
  },
  directives: {
    Ripple,
  },

  data() {
    return {
      name: "",
      rows: 100,
      medias: [],
      locale: this.$i18n.locale,
      baseUrl: settings.apiBaseUrl,
      currentPage: 1,
      mediaDatas: [],
      startDate: null,
      endDate: null,
    };
  },
  watch: {
    currentPage: {
      handler: function (newVal, oldVal) {
        this.getMedias(newVal);
      },
      deep: true,
    },
  },
  methods: {
    copy(url) {
      navigator.clipboard.writeText(url).then(
        function () {
          console.log("Copied!");
        },
        function () {
          console.log("Copy error");
        }
      );
    },
    handleMediaUpload(event) {
      setTimeout(() => {
        this.postMedias();
      }, 1000);
    },
    getMedias(page) {
      endpoints
        .getMedias(
          page,
          this.startDate,
          this.endDate,
          this.name,
          this.$i18n.locale,
          () => {}
        )
        .then((data) => {
          this.mediaDatas = [...data.response.data];
          this.rows = data.response.meta.total;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    postMedias() {
      let formData = new FormData();
      for (var i = 0; i < this.$refs.medias.files.length; i++) {
        let file = this.$refs.medias.files[i];
        formData.append("medias[" + i + "]", file);
      }
      endpoints
        .postMedias(formData, this.$i18n.locale, () => {})
        .then((data) => {
          this.medias = [];
          this.getMedias(this.currentPage);
          this.$swal({
            icon: "success",
            title: "Kayıt başarılı!",
            text: "Yeni dosyalar eklendi.",
            customClass: {
              confirmButton: "btn btn-success",
            },
          })
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
  mounted() {
    this.getMedias(this.currentPage);
  },
  setup() {},
};
</script>
